import { useEffect, useState } from "react";
import { Megaphone, X } from "lucide-react";
import { get } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const DISMISSED_KEY = "ww-platform-dashboard-alert-dismissed";
const UPDATED_EVENT = "platform-dashboard-alert-updated";

export const PlatformDashboardAlert = () => {
  const { profile } = useAuth();
  const [alert, setAlert] = useState(null);
  const [dismissedVersion, setDismissedVersion] = useState(() => localStorage.getItem(DISMISSED_KEY));

  useEffect(() => {
    let active = true;
    const refresh = () => get("/dashboard-alert").then((next) => {
      if (active) setAlert(next);
    }).catch(() => {
      if (active) setAlert(null);
    });
    refresh();
    window.addEventListener(UPDATED_EVENT, refresh);
    return () => {
      active = false;
      window.removeEventListener(UPDATED_EVENT, refresh);
    };
  }, []);

  const userRoles = new Set([profile?.role, ...(profile?.user_types || [])].filter(Boolean));
  if (!alert?.message || dismissedVersion === alert.version || !alert.roles?.some((role) => userRoles.has(role))) return null;
  return (
    <aside role="status" className="flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-950" data-testid="platform-dashboard-alert">
      <Megaphone className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <p className="min-w-0 flex-1 whitespace-pre-wrap break-words">{alert.message}</p>
      <button type="button" className="-mr-2 -mt-2 flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-amber-900 hover:bg-amber-100" aria-label="Dismiss alert" title="Dismiss alert" data-testid="platform-dashboard-alert-dismiss" onClick={() => {
        localStorage.setItem(DISMISSED_KEY, alert.version);
        setDismissedVersion(alert.version);
      }}>
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
    </aside>
  );
};